export const SHOW_ITEM_DETAILS_ACTION = 'SHOW_ITEM_DETAILS_ACTION';
export const SHOW_ITEM_DETAILS_SUCCESS_ACTION =
  'SHOW_ITEM_DETAILS_SUCCESS_ACTION';
export const SHOW_ITEM_DETAILS_FAILURE_ACTION =
  'SHOW_ITEM_DETAILS_FAILURE_ACTION';
export const SHOW_ITEM_DETAILS_RESET_ACTION = 'SHOW_ITEM_DETAILS_RESET_ACTION';